import {useCallback, useState} from 'react'

import {DeleteSavedViewDialog} from '../components/views/DeleteSavedViewDialog'
import type {SavedView} from '../components/views/types'

interface UseDeleteSavedViewDialogOptions {
  owner: string
  repo: string
  onDeleted?: (view: SavedView) => void
}

export function useDeleteSavedViewDialog({owner, repo, onDeleted}: UseDeleteSavedViewDialogOptions) {
  const [pendingDelete, setPendingDelete] = useState<SavedView | null>(null)

  const openDeleteDialog = useCallback((view: SavedView) => {
    setPendingDelete(view)
  }, [])

  const deleteDialog = pendingDelete ? (
    <DeleteSavedViewDialog
      view={pendingDelete}
      owner={owner}
      repo={repo}
      onClose={() => setPendingDelete(null)}
      onSuccess={() => onDeleted?.(pendingDelete)}
    />
  ) : null

  return {openDeleteDialog, deleteDialog}
}
